
document.querySelectorAll('.label-image').forEach(label => {
    const popup = label.closest('.variant-input')?.querySelector('.variant-desc-popup');

    if (!popup) return;

    label.addEventListener('mouseenter', () => {
        popup.classList.add('active');
    });

    label.addEventListener('mouseleave', () => {
        setTimeout(() => {
            if (!popup.matches(':hover') && !label.matches(':hover')) {
                popup.classList.remove('active');
            }
        }, 10);
    });

    popup.addEventListener('mouseenter', () => {
        popup.classList.add('active');
    });

    popup.addEventListener('mouseleave', () => {
        setTimeout(() => {
            if (!label.matches(':hover')) {
                popup.classList.remove('active');
            }
        }, 10);
    });
});

// Old Code START
// document.addEventListener("DOMContentLoaded", function () {
//     const fieldset = document.querySelector(".variants-countertop");
//     const countertopPopup = document.getElementById("countertop-popup");
//     const closeButton = document.querySelector(".js-close-countertop-popup");
//     let hoverTimeout;
//     let isHoveredOverPopup = false;

//     function openPopup(variantInput) {
//         if (!variantInput) return;
//         const popup = variantInput.querySelector(".variant-desc-popup");
//         if (!popup) return;

//         const title = popup.querySelector(".countertop-title")?.textContent.trim() || "";
//         const desc = popup.querySelector(".countertop-desc")?.textContent.trim() || "";
//         const img = popup.querySelector("img")?.src || "";
//         const img_zoom = popup.querySelector(".image-zoom-link")?.dataset.src || "";

//         const popTitle = countertopPopup.querySelector(".pop-countertop-title");
//         const popDesc = countertopPopup.querySelector(".pop-countertop-desc");
//         const popImage = countertopPopup.querySelector(".pop-countertop-image");
//         const popZoomLink = countertopPopup.querySelector(".zoom-link");

//         if (popTitle) popTitle.textContent = title;
//         if (popDesc) popDesc.textContent = desc;
//         if (popImage) popImage.src = img;
//         if (popZoomLink) popZoomLink.dataset.src = img_zoom || img;

//         countertopPopup.classList.add("drawer--is-open");
//     }

//     function closePopup() {
//         if (!isHoveredOverPopup) {
//             countertopPopup.classList.remove("drawer--is-open");
//         }
//     }

//     if (fieldset && countertopPopup) {
//         function handleMouseOver(event) {
//             if (window.innerWidth >= 1140) {
//                 const variantInput = event.target.closest(".variant-input");
//                 if (variantInput) {
//                     clearTimeout(hoverTimeout);
//                     openPopup(variantInput);
//                 }
//             }
//         }

//         function handleMouseOut(event) {
//             if (window.innerWidth >= 1140) {
//                 hoverTimeout = setTimeout(() => {
//                     closePopup();
//                 }, 200);
//             }
//         }

//         function handleMouseOverPopup() {
//             clearTimeout(hoverTimeout);
//             isHoveredOverPopup = true;
//         }

//         function handleMouseOutPopup() {
//             isHoveredOverPopup = false;
//             hoverTimeout = setTimeout(() => {
//                 closePopup();
//             }, 200);
//         }

//         function handleClick(event) {
//             if (window.innerWidth < 1140) {
//                 if (event.target.matches("input[type='radio'], input[type='checkbox']")) {
//                     openPopup(event.target.closest(".variant-input"));
//                 }
//             }
//         }

//         fieldset.addEventListener("mouseover", handleMouseOver);
//         fieldset.addEventListener("mouseout", handleMouseOut);
//         fieldset.addEventListener("click", handleClick);
//         countertopPopup.addEventListener("mouseover", handleMouseOverPopup);
//         countertopPopup.addEventListener("mouseout", handleMouseOutPopup);

//         document.addEventListener("click", function (event) {
//             if (!countertopPopup.contains(event.target) && !fieldset.contains(event.target)) {
//                 closePopup();
//             }
//         });

//         if (closeButton) {
//             closeButton.addEventListener("click",function (){
//                 countertopPopup.classList.remove("drawer--is-open");
//             });
//         }
//     }
// });
// Old Code END

// Replaced by code START
document.addEventListener("DOMContentLoaded", function () {
    const fieldset = document.querySelector(".variants-countertop");
    const countertopPopup = document.getElementById("countertop-popup");
    const closeButton = document.querySelector(".js-close-countertop-popup");
    let hoverTimeout;
    let isHoveredOverPopup = false;
    let isHoveredOverVariant = false;

    function openPopup(variantInput) {
        if (!variantInput) return;
        const popup = variantInput.querySelector(".variant-desc-popup");
        if (!popup) return;

        const title = popup.querySelector(".countertop-title")?.textContent.trim() || "";
        const desc = popup.querySelector(".countertop-desc")?.innerHTML.trim() || "";
        const img = popup.querySelector("img")?.src || "";
        const img_zoom = popup.querySelector(".image-zoom-link")?.dataset.src || "";

        const popTitle = countertopPopup.querySelector(".pop-countertop-title");
        const popDesc = countertopPopup.querySelector(".pop-countertop-desc");
        const popImage = countertopPopup.querySelector(".pop-countertop-image");
        const popZoomLink = countertopPopup.querySelector(".zoom-link");

        if (popTitle) popTitle.textContent = title;
        if (popDesc) popDesc.innerHTML = desc;
        if (popImage) popImage.src = img;
        if (popZoomLink) popZoomLink.dataset.src = img_zoom || img;

        countertopPopup.classList.add("drawer--is-open");
    }

    function closePopup() {
        if (!isHoveredOverPopup && !isHoveredOverVariant) {
            countertopPopup.classList.remove("drawer--is-open");
        }
    }

    if (fieldset && countertopPopup) {
        fieldset.addEventListener("mouseover", function (event) {
            if (window.innerWidth >= 1140) {
                const variantInput = event.target.closest(".variant-input");
                if (variantInput) {
                    isHoveredOverVariant = true;
                    clearTimeout(hoverTimeout);
                    
                    openPopup(variantInput);
                }
            }
        });

        fieldset.addEventListener("mouseout", function (event) {
            if (window.innerWidth >= 1140) {
                const related = event.relatedTarget;
                // Ignore if moving into the popup
                if (countertopPopup.contains(related)) return;

                isHoveredOverVariant = false;
                hoverTimeout = setTimeout(() => {
                    closePopup();
                }, 200);
            }
        });

        countertopPopup.addEventListener("mouseover", function () {
            isHoveredOverPopup = true;
            clearTimeout(hoverTimeout);
        });

        countertopPopup.addEventListener("mouseout", function (event) {
            const related = event.relatedTarget;
            if (fieldset.contains(related)) return;

            isHoveredOverPopup = false;
            hoverTimeout = setTimeout(() => {
                closePopup();
            }, 200);
        });

        fieldset.addEventListener("click", function (event) {
            if (window.innerWidth < 1140) {
                if (event.target.matches("input[type='radio'], input[type='checkbox']")) {
                    openPopup(event.target.closest(".variant-input"));
                }
            }
        });

        document.addEventListener("click", function (event) {
            if (!countertopPopup.contains(event.target) && !fieldset.contains(event.target)) {
                countertopPopup.classList.remove("drawer--is-open");
            }
        });

        if (closeButton) {
            closeButton.addEventListener("click", function () {
                countertopPopup.classList.remove("drawer--is-open");
            });
        }
    }
});
// Replaced by code END


document.querySelectorAll(".js-variants-tab-btn").forEach(button => {
    button.addEventListener("click", function () {
        let type = this.getAttribute("data-type");
        let contents = document.querySelectorAll("div[data-content]");
        let buttons = document.querySelectorAll(".js-variants-tab-btn");

        buttons.forEach(btn => btn.classList.remove("active"));
        this.classList.add("active");

        if (type === "all") {
            contents.forEach(div => div.classList.remove("hidden"));
        } else {
            contents.forEach(div => {
                div.classList.toggle("hidden", div.getAttribute("data-content") !== type);
            });
        }

        document.querySelectorAll(".countertop-filtered-options").forEach(container => {
            const children = container.querySelectorAll("div[data-content]");
            const allHidden = Array.from(children).every(child => child.classList.contains("hidden"));

            container.classList.toggle("hidden", allHidden);
        });
    });
});


if (window.Fancybox) {
    Fancybox.bind('[data-fancybox]', {
        // options
    });
} else {
    console.warn("Fancybox not loaded yet");
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".js-zoom-link").forEach(function (link) {
        link.addEventListener("click", function (event) {
            event.preventDefault();
            let imageSrc = link.getAttribute("data-src");
            setTimeout(function () {
                Fancybox.show([{ src: imageSrc, type: "image" }]);
            }, 100);
        });
    });
});



function initFaucetsPopup(){
    const fieldset = document.getElementById("product-upsell");
    const popup = document.getElementById("faucet-popup");

    let isHoveredOverPopup = false;

    function openPopup(variantInput, isHover) {
        if (!variantInput) return;
        const img = variantInput.querySelector("img")?.src || "";
        const description = variantInput.querySelector('.description').content.textContent.trim();
        if (!img) return;
        const popImage = popup.querySelector(".pop-faucet-image");
        const popDescription = popup.querySelector(".desc-wrap");
        if (popImage) popImage.src = img;
        if (popDescription) popDescription.textContent = description;
        popup.classList.add("drawer--is-open");

        if(isHover){
            variantInput.addEventListener("mouseleave", () => {
                closePopup();
            }, { once: true });
        }
    }
    function closePopup() {
        if (!isHoveredOverPopup) {
            popup.classList.remove("drawer--is-open");
        }
    }
    if (fieldset && popup) {
        fieldset.addEventListener("mouseover", (event) => {
            if (window.innerWidth >= 1140) {
                const variantInput = event.target.closest(".variant-input");
                if (variantInput) {
                    openPopup(variantInput, true);
                }
            }
        });
    }
}

function initColorVariantPopUp() {
    const fieldset = document.querySelector(".variants-color");
    const popup = document.getElementById("color-variant-popup");
    const closeButton = document.querySelector(".js-close-color-variant-popup");

    if (!fieldset || !popup) {
        return;
    }

    let isHoveredOverPopup = false;

    function openPopup(color, image, information) {
        const popDesc = popup.querySelector(".pop-desc");
        const popImage = popup.querySelector(".pop-image");
        const popColor = popup.querySelector(".color-div");

        // if( color.length > 1 ){
        //     popColor.style.backgroundColor = color;
        //     popColor.classList.remove('d-none');
        //     popImage.classList.add('d-none');
        // }else{
        //     popImage.src = image;
        //     popImage.classList.remove('d-none');
        //     popColor.classList.add('d-none');
        // }

        if (popImage) {
            popImage.src = image;
            popImage.classList.remove('d-none');
            popColor.classList.add('d-none');
        } else {
            popColor.style.backgroundColor = color;
            popColor.classList.remove('d-none');
            popImage.classList.add('d-none');
        }

        popDesc.innerHTML = information;
        popup.classList.add("drawer--is-open");
    }

    function closePopup() {
        if (!isHoveredOverPopup) {
            popup.classList.remove("drawer--is-open");
        }
    }

    function initPop(variantInput, isHover){
        const scriptTag = variantInput.querySelector('script[type="application/json"]');
        if (scriptTag) {
            const jsonData = JSON.parse(scriptTag.textContent.trim());
            const information = jsonData.information.replace(/\n/g, "<br>")
            const image = jsonData.image;
            const color = jsonData.color;
            // if (color && image) {
                openPopup(color, image, information);
                if(isHover){
                    variantInput.addEventListener("mouseleave", () => {
                        closePopup();
                    }, { once: true });
                }

            // }
        }
    }

    if (fieldset && popup) {
        fieldset.addEventListener("mouseover", (event) => {
            if (window.innerWidth >= 1140) {
                const variantInput = event.target.closest(".variant-input");
                if (variantInput) {
                    initPop(variantInput, true)
                }
            }
        });

        fieldset.addEventListener("click", (event) => {
            if (window.innerWidth < 1140) {
                const variantInput = event.target.closest(".variant-input");
                const isRadioChecked = variantInput.querySelector('[type="radio"]').checked;
                
                if (variantInput && isRadioChecked) {
                    initPop(variantInput, false);
                }
            }
        });
    }

    document.addEventListener("click", function (event) {
        if (
            popup && fieldset &&
            !popup.contains(event.target) &&
            !fieldset.contains(event.target)
        ) {
            closePopup();
        }
    });

    if (closeButton) {
        closeButton.addEventListener("click", closePopup);
    }

}
function hideTextOnB2bForm(){
    setTimeout(() => {
        const wizardContents = document.querySelectorAll('.wizard__content');

        wizardContents.forEach(container => {
            const panelsDiv = container.querySelector('.panels');

            if (panelsDiv) {
                const nextElement = panelsDiv.nextElementSibling;

                if (nextElement && nextElement.tagName.toLowerCase() === 'p') {
                    nextElement.classList.add('hidden-text');
                }
            }
        });
    }, 1500);
}

document.addEventListener("DOMContentLoaded", function () {
    initColorVariantPopUp();
    initFaucetsPopup();
    hideTextOnB2bForm();



    var insta_target = document.querySelector('#insta-feed');
    var elemViewport = (document.compatMode === "CSS1Compat") ?  document.documentElement : document.body;

    var WidthViewport = elemViewport.clientWidth;


    // Check if page is NOT a collection template
    if (!document.body.classList.contains('template-collection')) {
        if (WidthViewport > 767) {
            if (insta_target) {
                setTimeout(() => {
                    initscrollTrigger();
                }, 1000);
            } else {
                initscrollTrigger();
            }
        }

        gsap.registerPlugin(ScrollTrigger);

        function initscrollTrigger() {
            gsap.timeline({
                scrollTrigger: {
                    trigger: '.shopify-section-group-footer-group',
                    scrub: true,
                    start: 'top bottom',
                    end: 'bottom bottom',
                    invalidateOnRefresh: true,
                    // markers: true
                }
            }).fromTo('.shopify-section-group-footer-group .site-footer', {
                yPercent: -50
            }, {
                yPercent: 0,
                ease: 'none'
            });
        }
    }
});

// Toggle searching START
document.addEventListener('DOMContentLoaded', () => {
    const searchContainer = document.querySelector('.site-header__search-container');
    let lastScrollTop = 0;

    const updateState = () => {
        searchContainer.classList[window.innerWidth <= 768 ? 'add' : 'remove']('is-active');
    };

    updateState();

    window.addEventListener('resize', updateState);

    function toggleVisibility() {
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if (window.scrollY > 85) {
            const isMobile = window.innerWidth <= 768;
            searchContainer.classList[isMobile && currentScroll < lastScrollTop ? 'add' : 'remove']('is-active');
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    }

    window.addEventListener("scroll", toggleVisibility);
});
// Toggle searching END

// Filter Side Bar Toggling START
document.addEventListener('DOMContentLoaded', function () {
    if (!document.body.classList.contains('template-collection')) return;
    
    const filterToggle = document.querySelector('.js-sidebar-open-collection-filters');
    const filterSidebar = document.querySelector('.grid__item--sidebar');

    if (!filterToggle || !filterSidebar) return;

    if (window.innerWidth > 768) {
        filterSidebar.classList.add('hidden');
    }
});

class FilterSideBarToggle extends HTMLElement {
    constructor() {
        super();

        this.filterToggle = null;
        this.filterSidebar = null;

        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
        if (!this.shouldRun()) return;

        this.filterToggle = document.querySelector(
        '.js-sidebar-open-collection-filters'
        );
        this.filterSidebar = document.querySelector('.grid__item--sidebar');

        if (!this.filterToggle || !this.filterSidebar) return;

        this.filterToggle.addEventListener('click', this.handleToggleClick);
        window.addEventListener('resize', this.handleResize);

        this.handleResize();
    }

    disconnectedCallback() {
        this.filterToggle?.removeEventListener('click', this.handleToggleClick);
        window.removeEventListener('resize', this.handleResize);
    }

    shouldRun() {
        return document.body.classList.contains('template-collection');
    }

    handleToggleClick() {
        if (!this.filterSidebar) return;

        if (!document.startViewTransition) {
            this.toggleSidebar();
            return;
        }

        document.startViewTransition(() => {
            this.toggleSidebar();
        });
    }

    handleResize() {
        if (!this.filterSidebar) return;

        if (window.innerWidth <= 768) {
            this.showSidebar();
        }
    }

    toggleSidebar() {
        this.filterSidebar.classList.toggle('hidden');
    }

    showSidebar() {
        this.filterSidebar.classList.remove('hidden');
    }
}

customElements.define('filter-sidebar-toggle', FilterSideBarToggle);
// Filter Side Bar Toggling END

class GridColorSwatches extends HTMLElement {
    constructor () {
        super();

        this.swatches = this.querySelectorAll('.color-swatch');
        if (this.swatches.length === 0) return;

        this.gridItem = this.closest('.grid__item');
        if (!this.gridItem) return;

        this.imageElement = this.gridItem.querySelector('.grid__image-ratio image-element');
        if (!this.imageElement) return;

        this.image = this.imageElement.querySelector('img');
        if (!this.image) return;

        this.handleOn = this.handleOn.bind(this);
        this.handleAway = this.handleAway.bind(this);
    }

    connectedCallback () {
        this.swatches.forEach(swatch => {
            swatch.addEventListener('mouseover', this.handleOn);
        });
        this.swatches.forEach(swatch => {
            swatch.addEventListener('mouseleave', this.handleAway);
        });
    }

    disconnectedCallback () {
        this.swatches.forEach(swatch => {
            swatch.removeEventListener('mouseover', this.handleOn);
        });
        this.swatches.forEach(swatch => {
            swatch.removeEventListener('mouseleave', this.handleAway);
        });
    }
    
    handleOn (e) {
        const swatchProductSrc = e.target.dataset.featuredImage;

        const newImage = this.image.cloneNode(true);
        newImage.src = swatchProductSrc;
        newImage.srcset = swatchProductSrc;

        this.replaceImage(newImage);
    }

    handleAway (e) {
        this.replaceImage(this.image);
    }

    replaceImage (image) {
        this.imageElement.innerHTML = "";
        this.imageElement.appendChild(image);
    }
}

customElements.define('grid-color-swatches', GridColorSwatches);


document.addEventListener('DOMContentLoaded', () => {
    class MenuAccordion extends HTMLElement {
        constructor () {
            super();
    
            this.trigger = this.querySelector('.secondary-link-head');
            if (!this.trigger) return;
    
            this.menu = this.querySelector('.secondary-link-menu');
            if (!this.menu) return;
    
            this.onClick = this.onClick.bind(this);
        }
    
        connectedCallback () {
            this.trigger.addEventListener('click', this.onClick);
        }
    
        disconnectedCallback () {
            this.trigger.removeEventListener('click', this.onClick);
        }
    
        onClick () {
            this.trigger.classList.toggle('is-open');
            this.menu.classList.toggle('hidden');
        }

        // onClick () {
        //     this.trigger.classList.toggle('is-open');

        //     const isOpen = this.menu.classList.contains('is-open');
    
        //     if (isOpen) {
        //         this.menu.style.height = `${this.menu.scrollHeight}px`;
        //         requestAnimationFrame(() => {
        //             this.menu.style.height = '0px';
        //         });
        //         this.menu.classList.remove('is-open');
        //     } else {
        //         this.menu.style.height = `${this.menu.scrollHeight}px`;
        //         this.menu.classList.add('is-open');
    
        //         this.menu.addEventListener(
        //         'transitionend',
        //         () => {
        //             this.menu.style.height = 'auto';
        //         },
        //         { once: true }
        //         );
        //     }
        // }
    }
    
    customElements.define('menu-accordion', MenuAccordion);
});

class SearchRecentlyViewed extends HTMLElement {
    constructor () {
        super();
        this.swiper = null;
    }

    connectedCallback () {
        this.swiperEl = this;
        this.prevArrow = this.closest('.predictive-search-recommendations').querySelector('.predictive-search-arrow--prev');
        this.nextArrow = this.closest('.predictive-search-recommendations').querySelector('.predictive-search-arrow--next');
        this.initSwiper();
    }

    initSwiper () {
        if (!this.swiperEl) return;

        this.swiper = new Swiper(this.swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            navigation: {
                nextEl: this.nextArrow,
                prevEl: this.prevArrow,
            },
            scrollbar: {
                el: ".swiper-scrollbar"
            },
            // mousewheel: {
            //     forceToAxis: true,
            //     sensitivity: 1,
            //     releaseOnEdges: true
            // }
        });
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    }
}

if (!customElements.get('search-recently-viewed')) {
    customElements.define('search-recently-viewed', SearchRecentlyViewed);
}

class SearchTabs extends HTMLElement {
    constructor () {
        super();

        this.toggleTab = this.toggleTab.bind(this);
    }

    connectedCallback() {
        this.togglers = this.querySelectorAll('.js-predictive-search-tab');
        this.contents = this.querySelectorAll('.js-predictive-search-tabs-content');

        this.togglers.forEach((toggler, index) => {
            const handler = (e) => this.toggleTab(e, index);

            toggler._tabHandler = handler;
            toggler.addEventListener('click', handler);
        });
    }

    disconnectedCallback() {
        this.togglers.forEach((toggler) => {
            toggler.removeEventListener('click', toggler._tabHandler);
        });
    }

    toggleTab (e, index) {
        this.togglers.forEach(toggler => toggler.classList.remove('active'));
        this.contents.forEach(content => content.classList.add('hidden'));

        e.currentTarget.classList.add('active');
        this.contents[index].classList.remove('hidden');
    }
}

if (!customElements.get('search-tabs')) {
    customElements.define('search-tabs', SearchTabs);
}

(function () {
    var path = window.location.pathname;
    var search = window.location.search;
    var normalized = path;

    // Collapse multiple slashes
    normalized = normalized.replace(/\/+/g, "/");

    // Remove trailing slash (except homepage)
    if (normalized.length > 1 && normalized.endsWith("/")) {
        normalized = normalized.slice(0, -1);
    }

    // If changed → redirect
    if (normalized !== path) {
        window.location.replace(normalized + search);
    }
})();